<template>
  <div>
    <h4 class="text-primary mb-base">{{$t('profile.profile')}}</h4>
    <profile-card />
  </div>
</template>

<script>
import ProfileCard from "../components/dashboard/cards/ProfileCard";
export default {
  components: {
    ProfileCard
  },
  created(){
   // document.querySelector('#avper').click();
  }
};
</script>

<style>
</style>
